export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title animate">Hey, I'm Muhammad Zafran</p>
          <h1 className="hero--section--title animate">
            <span className="hero--section-title--color">Data Scientist</span>{" "}
            <br />
            Web Developer
          </h1>
          <p className="hero--section-description animate">
            I am a creative and passionate Python Data Analyst and Full-Stack python developer and looking for an opportunity.
            <br /><mark>Do you want to hire me?</mark>
          </p>
        </div>
        
        <div className="hero-btn animate">
        <a className="btn btn-primary" href="mailto:zafranraja5@gmail.com" target="_blank">HIRE ME</a>
        <a className="btn btn-primary" href="https://github.com/mohzaf66" target="_blank">MY GITHUB</a>
        </div>
      
      </div>
      <div className="hero--section--img animate">
        <img className="animate" src="./img/hero-section-img.png" alt="Hero Section" />
      </div>
    </section>
  );
}
